import Service from '@ember/service';

export default Service.extend({
  reasons: Object.freeze([
    '',
    'Ask',
    'Follow Up',
    'Increase',
    'Newsletter',
    'Saying Hi',
    'Thank You',
    'Other',
  ]),
  mediums: Object.freeze([
    '',
    'Call',
    'Email',
    'FaceBook',
    'Face to Face',
    'Gift',
    'Letter',
    'Post Card',
    'Text',
    'FaceTime/Skype',
  ]),
});
